module.exports = {
    fr: {
        meta: {
            title: "Finalisez votre réservation"
        },
        eyebrow: "Étape 2 sur 3",
        title: "Finalisez votre réservation",
        lead: "Vérifiez votre trajet, puis réglez en ligne pour confirmer votre chauffeur.",
        help: "Une question avant de payer ?"
    },
    en: {
        meta: {
            title: "Complete your booking"
        },
        eyebrow: "Step 2 of 3",
        title: "Complete your booking",
        lead: "Check your trip, then pay online to confirm your driver.",
        help: "A question before paying?"
    },
    ru: {
        meta: {
            title: "Завершите бронирование"
        },
        eyebrow: "Шаг 2 из 3",
        title: "Завершите бронирование",
        lead: "Проверьте детали поездки и оплатите онлайн, чтобы подтвердить заказ водителя.",
        help: "Есть вопрос перед оплатой?"
    }
};
